var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-fade"}},[(_vm.isMaskScreenTips)?_c('div',{staticClass:"mask_nav_tips"},[_c('span',[_vm._v("推薦使用豎屏瀏覽哦~")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }